/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type OPMCalculator = {
  readonly id?: number;
  name: string;
  readonly panel_id?: string;
  valuation: number;
  cap_table?: number | null;
  equity_value?: string | null;
  risk_free_rate?: string | null;
  maturity?: string | null;
  volatility?: string | null;
  opm_date?: string | null;
  source_type?: OPMCalculator.source_type | null;
  source_approach_ref?: string | null;
  source_scenario_ref?: string | null;
};
export namespace OPMCalculator {
  export enum source_type {
    BACKSOLVE = 'backsolve',
    FUTURE_EXIT = 'future_exit',
    EQUITY_ALLOCATION = 'equity_allocation',
  }
}

